import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t-2 border-black dark:border-zinc-700 bg-white dark:bg-zinc-950 text-black dark:text-zinc-200"
    >
      <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs font-medium">
        <p className="max-w-xl leading-relaxed">
          ReviseAI is operated by Truzolex Ltd, a company registered in England &amp; Wales (company number 17126825).
        </p>
        <nav className="flex gap-5 flex-wrap font-bold">
          <Link to="/privacy" data-testid="footer-privacy" className="hover:underline underline-offset-4">
            Privacy
          </Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:underline underline-offset-4">
            Terms
          </Link>
          <a
            href="mailto:isleofsagacity@gmail.com"
            data-testid="footer-contact"
            className="hover:underline underline-offset-4"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
